import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeFormat',
    standalone: false
})
export class TimeFormatPipe implements PipeTransform {

  transform(start: Date | string | undefined, end: Date | string | undefined): string {
    const startDate = start? new Date(start) : new Date();
    const endDate = end ? new Date(end) : new Date();

    const ms = endDate.getTime() - startDate.getTime();

    if (isNaN(ms) || ms < 0) return 'Invalid duration';

    const hours = Math.floor(ms / 3600000);
    const minutes = Math.floor((ms % 3600000) / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);

    const parts: string[] = [];

    if (hours > 0) parts.push(`${hours}h`);

    if (minutes > 0 || hours > 0) {
      const mStr = hours > 0 ? minutes.toString().padStart(2, '0') : minutes.toString();
      parts.push(`${mStr}m`);
    }

    const sStr = (minutes > 0 || hours > 0) ? seconds.toString().padStart(2, '0') : seconds.toString();
    parts.push(`${sStr}s`);

    return parts.join(' ');
  }

}
